export default __webpack_public_path__ + "static/media/submitGrey.dd7033fc.svg";